import React, {useEffect, useState, useRef} from 'react';
import './MainCategoryNavigation.less';
import 'intersection-observer';
import {ChipList} from 'elements/chip-list/ChipList';
import {Chip} from 'elements/chip/Chip';
import Platform from '../../../platform';
import platform from "../../../platform";

export const MainCategoryNavigation = ({mainCategories = [], selectedMainCategory, onMainCategoryClick}) => {
	const selectedMainCategoryRef = useRef(null);
	const mainCategoriesContainerRef = useRef(null);


	useEffect(() => {

		if (selectedMainCategory.click) {
			return;
		}

		if (!selectedMainCategoryRef.current || !mainCategoriesContainerRef.current) {
			return;
		}
		if (mainCategories[0].id === selectedMainCategory.id) {
			mainCategoriesContainerRef.current.scrollLeft = 0;
			return;
		}
		if (platform.isFirefox) {
			selectedMainCategoryRef.current.scrollIntoView({
				block: "nearest",
			});
			return;
		}
		selectedMainCategoryRef.current.scrollIntoViewIfNeeded
			? selectedMainCategoryRef.current.scrollIntoViewIfNeeded()
			: selectedMainCategoryRef.current.scrollIntoView();

	}, [selectedMainCategory]);

	return (
		<div
			className={`main-category-navigation ${(!Platform.isAndroid || !Platform.isIOs) ? 'main-category-navigation--scroll' : ''}`}
			ref={mainCategoriesContainerRef}
		>
			<div className="main-category-navigation__container">
				<ChipList>
					{mainCategories.map((mainCategory) => {
						const isSelected = mainCategory.id === selectedMainCategory.id;
						return (
							<div
								key={'main-nav-cat-' + mainCategory.id}
								ref={isSelected ? selectedMainCategoryRef : null}
							>
								<Chip
									key={mainCategory.id}
									text={mainCategory.name}
									isSelected={isSelected}
									onClick={isSelected ? null : () => onMainCategoryClick(mainCategory.id)}
								/>
							</div>
						);
					})}
				</ChipList>
			</div>
		</div>
	);
};
